module.exports = {"BASE_URL":"http://127.0.0.1:7073/","SERVER_TIMEOUT":10000}


//////////////////
// WEBPACK FOOTER
// ./static/config.json
// module id = IuJc
// module chunks = 128